import clsx from 'clsx'

import { useDrawerContext } from './DrawerContext'

import styles from './DrawerTitle.module.scss'

type DrawerTitleProps = {
  visuallyHidden?: boolean
  children: React.ReactNode
}

export const DrawerTitle = ({
  visuallyHidden = false,
  children
}: DrawerTitleProps) => {
  const context = useDrawerContext()

  if (!context) {
    throw new Error('DrawerTitle must be used inside a <Drawer> component.')
  }

  return (
    <h2
      id={`${context.id}-label`}
      className={clsx(styles.title, { 'visually-hidden': visuallyHidden })}
    >
      {children}
    </h2>
  )
}

export default DrawerTitle
